 <div class="gutter">

	<header #header class="flx-col flx-gap-default">
			<h1 #headerTitle *ngIf="page.title">{{ page.title }}</h1>
			<div *ngIf="page.content">
				<app-ve [content]="page.content"></app-ve>
			</div>
	</header>
	<div class="filters-wrap flx-dynamic flx-gap-default flx-btwn-cntr-md">
		<div class="map-controls flx-dynamic flx-gap-default flx-cntr-cntr">
			<div class="resultswrap">
				<div class="postcode-results" *ngIf="(addresses | async).length && focused">
					<div class="flx-row flx-btwn-cntr" *ngFor="let address of (addresses | async)" (click)="showDistributors(address); focused = false">
						{{ address.formatted_address }}
						<svg class="icon">
							<use xlink:href="#icon-chevron-right"></use>
						</svg>
					</div>
				</div>
				<mat-form-field appearance="outline">
					<mat-label i18n="@@address">Adres</mat-label>
					<input matInput [(ngModel)]="postcode" (ngModelChange)="postcodeChange($event)" (focus)="focused = true">
				</mat-form-field>
			</div>

			<mat-form-field  appearance="outline">
				<mat-label i18n="@@mapradius">W promieniu</mat-label>
				<mat-select (selectionChange)="changeRadius($event)" [value]="radius">
					<mat-option [value]="0">-</mat-option>
					<mat-option [value]="100">100 km</mat-option>
					<mat-option [value]="50">50 km</mat-option>
					<mat-option [value]="25">25 km</mat-option>
					<mat-option [value]="10">10 km</mat-option>
				</mat-select>
			</mat-form-field>

			<button class="flat-button primary" (click)="getCurrentLocation()" i18n="@@findme">Znajdź mnie</button> 		  	 
			<!-- <button class="flat-button primary" (click)="reset()"><svg class="icon icon-xl icon-close"><use xlink:href="#icon-close"></use></svg></button>--> 
			<div *ngIf="loading" class="loader-circle"></div>

			<div class="postcode-results-back" *ngIf="(addresses | async).length && focused" (click)="focused = false"></div>
		</div>
				

		<div class="flx-dynamic flx-gap-default flx-cntr-cntr">
			<p i18n>Chcesz powiększyć naszą sieć sprzedaży?</p>
			<a class="flat-button primary" [routerLink]="['/'+path_register]" i18n>Zarejestruj konto</a>
		</div>
	</div>


	<div class="flx-dynamic">
		<div class="w-33" *ngIf="markers_available?.length > 0 || localeId == 'pl'">
			<mat-tab-group (selectedTabChange)="onTabChanged($event);">
				<mat-tab label="{{ tab.title }}" *ngFor="let tab of tabs; let t = index">
					<div class="flx-col flx-gap-default">
					<div *ngFor="let shop of tab.distributors; let i = index" class="distributor flx-col flx-gap-default {{ shop.buttontext }}">
						<div class="badges">
							<span class="badge {{ shop.buttontext }}" *ngIf="shop.buttontext == 'gold'" i18n>Punkt fabryczny</span>
							<ng-container *ngFor="let s of shop.type">
								<span class="badge" *ngIf="services[+s]">{{ services[+s].title }}</span>
							</ng-container>
						</div>
						<div class="flx-col">
							<h3>{{ shop.title }}</h3>

							<h4 i18n="@@adrespoint">Adres punktu</h4>
							<p *ngIf="shop.description" [innerHtml]="shop.description"></p>
							<p *ngIf="shop.extra_1"><a [href]="'mailto:' + shop.extra_1">{{ shop.extra_1 }}</a></p>
							<p *ngIf="shop.extra_2"><a [href]="'tel:' + shop.extra_2">{{ shop.extra_2 }}</a></p>
							<p *ngIf="shop.extra_3"><a [href]="'tel:' + shop.extra_3">{{ shop.extra_3 }}</a></p>
							
						</div>
						<div class="flx-row flx-gap-default">
							<a class="stroked-button w-50" *ngIf="shop.path" [routerLink]="['/dealer', shop.path]" i18n="@@bcard">Wizytówka</a>
							<button class="stroked-button w-50" (click)="zoomMarker(shop.id, t)" i18n>Pokaż na mapie</button>
						</div>
					</div>
					</div>
				</mat-tab>
			</mat-tab-group>
		</div>

		<div #mapwrap class="flx-grw" *ngIf="isBrowser && mapLoaded$ | async">
			<google-map
			width="100%"
			height="100%"
			[zoom]="zoom"
			[center]="(center | async)"
			[options]="options">
			<map-circle [center]="(center | async)" [radius]="radius"></map-circle>
			<map-marker #somemarker="mapMarker" *ngFor="let m of markers_available; let i = index" 
			(mapClick)="openInfo(somemarker, m)"
			[options]="{icon: (m.buttontext == 'gold' ? '/assets/map_gold.png' : '/assets/map_red.png')}"
			[position]="{lat: +m.horizontalalign ,lng: +m.verticalalign}">
			</map-marker>
			<map-info-window>
			<h4><a *ngIf="markerInfoSelected" [routerLink]="['/dealer', markerInfoSelected.path]">{{ infoTitle }}</a></h4>
			<div [innerHtml]="infoContent"></div>
			<a class="stroked-button w-100 mt" *ngIf="markerInfoSelected" [routerLink]="['/dealer', markerInfoSelected.path]" i18n="@@bcard">Wizytówka</a>
			<a class="stroked-button w-100 mt" *ngIf="markerInfoSelected" [routerLink]="['/dealer', markerInfoSelected.path]"  fragment="contact" i18n="@@contact">Kontakt</a>
			</map-info-window>
			</google-map>
		</div>
	</div>
</div>